import axios from 'axios'
import Vue from 'vue'

Vue.prototype.$ajax = axios;
// var baseURL: 'https://api-prod.tuoluohuodong.com',
// var baseURL: 'http://192.168.1.131:8080/api',
// var baseURL= 'https://retouch-dev-api.tuoluohuodong.com/api';
var baseURL = process.env.BASE_API
var baseURLS = process.env.BASE_APIS
let Requests = axios.create({

})

Requests.post = function (url, parameters, callback) {
  var url = baseURL + url
  let token = '';
  if (localStorage.getItem("userInfo")) {
    token = JSON.parse(localStorage.getItem("userInfo")).token
  }
  axios.defaults.headers.common["token"] = token;
  axios.post(url, parameters, callback).then(res => {
    callback(res)
  }).catch(err => {});
}
Requests.posts = function (url, parameters, callback) {
  var url = baseURLS + url
  let token = '';
  if (localStorage.getItem("userInfo")) {
    token = JSON.parse(localStorage.getItem("userInfo")).token
  }
  axios.defaults.headers.common["token"] = token;
  axios.post(url, parameters, callback).then(res => {
    callback(res)
  }).catch(err => {});
}
Requests.puts = function (url, parameters, callback) {
  var url = baseURL + url
  let token = '';
  if (localStorage.getItem("userInfo")) {
    token = JSON.parse(localStorage.getItem("userInfo")).token
  }
  axios.defaults.headers.common["token"] = token;
  axios.put(url, parameters, callback).then(res => {
    callback(res)
  }).catch(err => {});
}
Requests.get = function (url, data, callback) {
  var url = baseURL + url
  let token = '';
  if (localStorage.getItem("userInfo")) {
    token = JSON.parse(localStorage.getItem("userInfo")).token
  }
  axios.defaults.headers.common["token"] = token;
  axios.get(url, {
    params: data
  }).then(function (response) {
    callback(response.data);
  }).catch(function (err) {})
}

Requests.delete = function (url, data, callback) {
  var url = baseURL + url
  let token = '';
  if (localStorage.getItem("userInfo")) {
    token = JSON.parse(localStorage.getItem("userInfo")).token
  }
  axios.defaults.headers.common["token"] = token;
  axios.delete(url, {
    params: data
  }).then(function (response) {
    callback(response.data);
  }).catch(function (err) {})
}

Requests.getExcelBinary = function (url, data, callback) {
  var url = baseURL + url
  let token = '';
  if (localStorage.getItem("userInfo")) {
    token = JSON.parse(localStorage.getItem("userInfo")).token
  }
  axios.defaults.headers.common["token"] = token;
  axios.get(url, {
    params: data,
    responseType: 'arraybuffer'
  }).then(function (response) {
    callback(response.data);
  }).catch(function (err) {})
}

Requests.up = function (url, data, callback) {
  var url = baseURL + url
  let params = new FormData()
  params.append('name', data.name)
  params.append('type', data.type)
  params.append('file', data.file)

  axios.post(url, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    callback(res)
  }).catch(error => {
    alert('更新用户数据失败' + error)
  })
}
export default Requests;



// WEBPACK FOOTER //
// ./src/utils/request.js